module.exports = __webpack_public_path__ + "img/trench.07d58157.jpg";